import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function QuestionTypeFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {query, translate, quizQuestionTypes: questionTypes} = context

  return (
    <ClearableSelect
      id="question-bank-type-filter"
      className={clsx(classes.select, "question-type")}
      value={query.type || ""}
      onChange={onChange}
      caption={translate('question-type')}
    >
      {questionTypes.map(type => (<MenuItem value={type.id} key={type.id}>{translate(type.name)}</MenuItem>))}
    </ClearableSelect>
  )
}

